import bar from '@/charts/themes/bar.js'
import bar1 from '@/charts/themes/bar1.js'
import bar0 from '@/charts/themes/bar0.js'
import hbar from '@/charts/themes/hbar.js'
import line from '@/charts/themes/line.js'
import ring from '@/charts/themes/ring.js'
import cleanInfo_ring1 from '@/charts/themes/cleanInfo_ring1.js'
import cleanInfo_ring2 from '@/charts/themes/cleanInfo_ring2.js'
import dashboardRing1 from '@/charts/themes/dashboardRing1.js'
import dashboardRing2 from '@/charts/themes/dashboardRing2.js'
import dashboardRing3 from '@/charts/themes/dashboardRing3.js'
import standard_ring from '@/charts/themes/standard_ring.js'
import mbar from '@/charts/themes/mbar.js'
import alarmLine from '@/charts/themes/alarm_line.js'

export default {
    bar,
    bar1,
    bar0,
    hbar,
    line,
    ring,
    cleanInfo_ring1,
    cleanInfo_ring2,
    dashboardRing1,
    dashboardRing2,
    dashboardRing3,
    standard_ring,
    mbar,
    alarmLine
}



// WEBPACK FOOTER //
// ./src/model/chartTheme.js